<template>
  <button
    type="button"
    role="switch"
    :aria-label="ariaLabel || undefined"
    :aria-checked="modelValue ? 'true' : 'false'"
    :disabled="disabled"
    :class="[
      'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border transition-colors duration-150',
      'focus-visible:ring-2 focus-visible:ring-indigo-300/60 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900',
      'disabled:cursor-not-allowed disabled:opacity-60',
    ]"
    :style="trackStyle"
    @click="toggle">
    <span
      class="pointer-events-none inline-block h-[18px] w-[18px] rounded-full bg-white shadow-sm ring-1 ring-black/10 transition-transform duration-150"
      :class="thumbClass"
    />
  </button>
</template>

<script>
export default {
  name: 'AppToggle',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  computed: {
    trackStyle() {
      if (this.modelValue) {
        return {
          borderColor: 'rgba(var(--team-color-rgb), 0.5)',
          backgroundColor: 'rgba(var(--team-color-rgb), 0.26)',
          boxShadow: 'inset 0 0 0 1px rgba(var(--team-color-rgb), 0.16)',
        }
      }

      return {
        borderColor: 'rgba(255, 255, 255, 0.14)',
        backgroundColor: 'rgba(255, 255, 255, 0.06)',
      }
    },
    thumbClass() {
      return this.modelValue ? 'translate-x-[21px]' : 'translate-x-1'
    },
  },
  methods: {
    toggle() {
      if (this.disabled) {
        return
      }

      this.$emit('update:modelValue', !this.modelValue)
    },
  },
}
</script>
